import util from './util';

// streamType  : Number 流设备对应类型：1：视频 2：音频 3：音视频 4：截屏 5：截屏+视频 6：截屏+音频
export const devicesMap = new Map([
  [1, 'video'],
  [2, 'audio'],
  [3, 'video_and_audio'],
  [4, 'screen'],
  [5, 'ScreenAndVideo'],
  [6, 'ScreenAndAudio'],
  [8, 'loudSpeaker'],
  [99, 'max']
]);
// status      : Number 设备状态 1开启 2关闭 3未找到
export const devicesStatusMap = new Map([
  [0, 'none'],
  [1, 'open'],
  [2, 'closed'],
  [3, 'unfound'], //未找到设备
  [4, 'error'], //异常
  [5, 'unauthorized'], //未授权
  [6, 'background'], //iOS 设备进入后台，设备摄像头被关闭，麦克风正常
  [7, 'max'] //超出0-max范围的状态值都属于异常
]);

export const logMap = {
  debug: 0,
  info: 1,
  warnning: 2,
  error: 3,
  critical: 4
};

export const roleMap = new Map([[1, 'teacher'], [2, 'student'], [3, 'assistant'], [4, 'parent']]);

export const getDeviceTypeKey = value => {
  return util.getMapKeyByValue(devicesMap, value);
};

export const getDeviceStatusKey = value => {
  return util.getMapKeyByValue(devicesStatusMap, value);
};

export default {
  getDeviceStatusKey,
  getDeviceTypeKey,
  logMap,
  devicesMap,
  devicesStatusMap,
  roleMap
};
